var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading_container"},[_c('v-icon',{staticClass:"loading_icon",attrs:{"name":"circle-notch","scale":"2","spin":""}}),_c('h2',{staticStyle:{"margin-top":"20px"}},[_vm._v(_vm._s(_vm.$t('loading')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }